exports = module.exports = require("/code/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".BlurredBackground{width:100%;height:100%;background-repeat:no-repeat;background-position:center;background-size:cover}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /code/~/css-loader?-minimize!/code/~/postcss-loader!/code/~/less-loader!./atoms/BlurredBackground.less
 ** module id = 315
 ** module chunks = 1 2
 **/